// Get references to the male and female images
const genderImages = document.querySelectorAll("#gender img");
const generateButton = document.getElementById("generate-button");

// Add click event listeners to the gender images
genderImages.forEach(img => {
    img.addEventListener("click", function () {
        // Remove the active class from all images
        genderImages.forEach(img => img.classList.remove("active"));
        // Add the active class to the clicked image
        img.classList.add("active");
    });
});

// Define arrays of Viking names for males and females
const vikingMaleNames = [
"Ragnar - meaning: 'warrior' or 'judgment warrior.'",
"Bjorn - meaning: 'bear.'",
"Ivar - meaning: 'archer' or 'warrior with a bow.'",
"Leif - meaning: 'descendant' or 'heir.'",
"Erik - meaning: 'eternal ruler' or 'ever-powerful.'",
"Olaf - meaning: 'ancestor's descendant' or 'forefather's relic.'",
"Harald - meaning: 'leader of the army' or 'war chief.'",
"Gunnar - meaning: 'brave warrior' or 'bold soldier.'",
"Thorstein - meaning: 'Thor's stone' or 'strong as Thor.'",
"Sigurd - meaning: 'victory guardian' or 'protector of victory.'",
"Rolf - meaning: 'famous wolf' or 'renowned wolf.'",
"Haldor - meaning: 'rock of Thor' or 'Thor's stone.'",
"Ingvar - meaning: 'warrior of Ing (Yngvi)' or 'hero of the god Ing.'",
"Ulf - meaning: 'wolf.'",
"Knut - meaning: 'knot' or 'knot of the world' (referring to the Earth's axis).",
"Hagen - meaning: 'high son' or 'son of the ruler' or even 'youthful one.'",
"Geir - meaning: 'spear' or 'spearman.'",
"Sven - meaning: 'young warrior' or 'young man.'",
"Einar - meaning: 'lone warrior' or 'one who fights alone.'",
"Vidar - meaning: 'forest warrior' or 'warrior of the woods.'",
"Torsten - meaning: 'Thor's stone' or 'strong as Thor.'",
"Ragnvald - meaning: 'powerful ruler' or 'mighty ruler.'",
"Oddvar - meaning: 'sword of the point' or 'pointed weapon' or 'pointable.'",
"Kjell - meaning: 'kettle' or 'helmet.'",
"Frode - meaning: 'wise' or 'learned.'",
"Stig - meaning: 'wanderer' or 'adventurer.'",
"Gorm - meaning: 'fierce' or 'ruthless.' alternatively: 'honorably good'",
"Alvar - meaning: 'elf warrior' or 'elf army.'",
"Bjarte - meaning: 'bright' or 'shining.'",
"Magnar - meaning: 'strength of the sea' or 'mighty one.'",
"Torbjorn - meaning: 'Thor's bear' or 'bear of Thor.'",
"Valdemar - meaning: 'famous ruler' or 'renowned for power.'",
"Gudmund - meaning: 'God's protection' or 'divine guardian.'",
"Eirik - meaning: 'eternal ruler' or 'forever powerful.'",
"Egil - meaning: 'edge of a sword' or 'edge of a blade.'",
"Arvid - meaning: 'eagle tree' or 'eagle of the woods.'",
"Thorleif - meaning: 'Thor's descendant' or 'heir of Thor.'",
"Verner - meaning: 'defending army' or 'army protector.'",
"Roar - meaning: 'famous warrior' or 'renowned fighter.'",
"Asgeir - meaning: 'god's spear' or 'divine spearman.'",
"Sigmund - meaning: 'victory protector' or 'guardian of victory.'",
"Rolf - meaning: 'famous wolf' or 'renowned wolf.'",
"Sigbjorn - meaning: 'victory bear' or 'bear of victory.'",
"Tormod - meaning: 'Thor's mind' or 'thoughts of Thor.'",
"Eskil - meaning: 'divine cauldron' or 'sacrificial bowl.'",
"Hroar - meaning: 'famous warrior' or 'renowned fighter.'",
"Kjeld - meaning: 'kettle' or 'helmet.'",
"Jorgen - meaning: 'earth worker' or 'tiller of the soil.'",
"Halfdan - meaning: 'half Danish' or 'partially Danish.'",
"Oskar - meaning: 'spear of the gods' or 'divine spear.'",
"Eilif - meaning: 'forever' or 'eternal' or 'immortal.'",
"Bjarne - meaning: 'bear' or 'bear-like.'",
"Alv - meaning: 'elf' or 'elfin.'",
"Ketil - meaning: 'cauldron' or 'helmet.'",
"Tore - meaning: 'Thor' or 'God of Thunder' or just 'Thunder.'",
"Oddbjorn - meaning: 'odd bear' or 'unique bear' but also 'sharp/edged bear.'",
"Magni - meaning: 'mighty' or 'strong.'",
"Arne - meaning: 'eagle' or 'eagle-like.'",
"Svein - meaning: 'boy' or 'youth.'",
"Valter - meaning: 'ruler of power' or 'mighty ruler.'",
"Sigvard - meaning: 'victory guardian' or 'protector of victory.'",
"Rasmus - meaning: 'beloved' or 'dear one.'",
"Ulfrik - meaning: 'wolf ruler' or 'wolf king.'",
"Gunnvald - meaning: 'battle power' or 'warrior strength.'",
"Frosten - meaning: 'frozen' or 'chilled.'",
"Karl - meaning: 'man' or 'free man.'",
"Eindride - meaning: 'one who rides alone' or 'solitary rider.'",
"Jarl - meaning: 'nobleman' or 'earl.'",
"Eskild - meaning: 'divine cauldron' or 'sacrificial bowl.'",
"Hrothgar - meaning: 'famous spear' or 'renowned spear.'",
"Tyr - meaning: 'god of war' or 'warrior god' or 'diety.'",
"Eivind - meaning: 'always a winner' or 'eternal winner.'",
"Kjartan - meaning: 'helmeted' or 'wearing a helmet' or 'sea warrior.'",
"Torben - meaning: 'Thor's bear' or 'bear of Thor' or 'thunder bear'",
"Steinar - meaning: 'stone warrior' or 'warrior of stone.'",
"Guttorm - meaning: 'god's thunder' or 'thunder of the gods.'",
"Rane - meaning: 'ruler' or 'king' or 'the one who decides.'",
"Torgrim - meaning: 'Thor's mask' or 'Thor's disguise.'",
"Sindre - meaning: 'small thunder' or 'little thunder god.'",
"Egill - meaning: 'edge of a sword' or 'sword's edge' or 'awe of terror' or just 'terror.'",
"Arnljot - meaning: 'eagle' or 'eagle-like.'",
"Dag - meaning: 'day' or 'sunlight.'",
"Halfdan - meaning: 'half Danish' or 'partially Danish.'",
"Orvar - meaning: 'arrow' or 'dart.'",
"Eskil - meaning: 'divine cauldron' or 'sacrificial bowl.'",
"Folke - meaning: 'people' or 'folk.'",
"Torgeir - meaning: 'Thor's spear' or 'spear of Thor.'",
"Gudleif - meaning: 'God's heritage' or 'divine legacy.'",
"Randulf - meaning: 'shield wolf' or 'wolf of the shield.'",
"Stein - meaning: 'stone' or 'rock.'",
"Algot - meaning: 'all good' or 'completely good.'",
"Knute - meaning: 'knot' or 'knot of the world.'",
"Arnulf - meaning: 'eagle wolf' or 'wolf of the eagle.' (complicated in English, could be meant as the strength of those two animals)",
"Sverre - meaning: 'wild' or 'untamed.'",
"Vetle - meaning: 'little' or 'small' or alternatively 'winter traveler.'",
"Rolf - meaning: 'famous wolf' or 'renowned wolf.'",
"Torkel - meaning: 'Thor's cauldron' or 'Thor's pot.'"
];

const vikingFemaleNames = [
"Astrid - meaning: 'Divine Strength' or 'Divinely Beautiful'",
"Freya - meaning: 'Noble Woman'",
"Sigrid - meaning: 'Beautiful Victory'",
"Ingrid - meaning: 'Hero's Daughter' or 'Fair' alternatively 'Ing's Beauty'",
"Helga - meaning: 'Holy Woman' or 'Sacred'",
"Gudrun - meaning: 'God's Secret' or 'Secret Rune' or 'God's Rune'",
"Thora - meaning: 'Thor's Arrow' or could be meant as female version of Thor's name",
"Sigrun - meaning: 'Victory Rune'",
"Frigg - meaning: 'Love' or 'Beloved'",
"Estrid - meaning: 'Divine Beauty'",
"Alfhild - meaning: 'Elf Battle'",
"Ragnhild - meaning: 'Mighty in Battle'",
"Hildegarde - meaning: 'Battle Garden' or simply another word for 'Protector'",
"Brynhild - meaning: 'Armor in Battle' or 'Battle Ready'",
"Eira - meaning: 'Mercy'",
"Yrsa - meaning: 'She-Bear'",
"Ingeborg - meaning: 'Protection of Ing' or 'Under the protection of Ing'",
"Freydis - meaning: Variation of 'Goddess of Love' or something close to 'Noblewoman of Love'",
"Aslaug - meaning: 'God's Strength' or 'Betrothed Woman' or 'Betrothed God'",
"Gyda - meaning: 'God's Gift'",
"Solveig - meaning: 'Sun's Path' or another translation would be 'Woman in charge of household'",
"Runa - meaning: 'Secret' or 'Secret tradition'",
"Gunnhild - meaning: 'Battle Maiden' or 'War-like Woman'",
"Elin - meaning: 'Bright One'",
"Hjordis - meaning: 'Sword Goddess'",
"Rannveig - meaning: 'Battle Decision' or more direct translation would be 'House War' - although it is not clear why the combination of these two words.'",
"Borghild - meaning: 'Fortress Battle' or something like 'Protector from Battle'",
"Thyra - meaning: 'God of Thunder'",
"Thordis - meaning: 'Thunder Goddess'",
"Eir - meaning: 'Mercy' or 'Peace'",
"Greta - meaning: 'Pearl'",
"Gerda - meaning: 'Protected' or 'Guardian'",
"Thyri - meaning: 'Thirst for Power' or possibly connected to god Thor in a sense like 'Thunder Warrior'",
"Idunn - meaning: 'Youth' or 'Forever Rejuvenated'",
"Liv - meaning: 'Life' - although that's closer to modern-day Scandinavian translation, in Old Norse it might have been closer to 'Shelter' or 'Protection'",
"Magnhild - meaning: 'Mighty in Battle' or 'Battle Strong'",
"Rikka - meaning: 'Powerful Ruler' or 'Tranquil Leader'",
"Dagny - meaning: 'New Day'",
"Alva - meaning: Another variation for 'Elf'",
"Eldrid - meaning: 'Fire Beautiful' - would be direct translation.'",
"Sigfrid - meaning: 'Beautiful Victory'",
"Signe - meaning: 'New Victory'",
"Sigyn - meaning: 'Loyalty' or 'Friend of Victory'",
"Thordis - meaning: 'Thunder Goddess'",
"Svanhild - meaning: 'Swan Battle' or 'Swan Warrior'",
"Jorunn - meaning: 'Loving Horses' or 'Horse Lover'",
"Ormhild - meaning: 'Serpent Battle' or 'Snake Battle'",
"Siv - meaning: 'Bride'",
"Ragna - meaning: 'Advice, Decision, Judgment' or female 'Judgment Warrior'",
"Bodil - meaning: 'Fight or Penitence' or possibly something like 'Remedy Battle'",
"Ingibjorg - meaning: 'Ing's Protection'",
"Gunhild - meaning: 'Battle Maiden' or a 'Warrior Devoted to Battle'",
"Estrid - meaning: 'Divine Beauty' (variation of Astrid)",
"Jofrid - meaning: 'Peaceful Rider' or 'Keeper of Peace'",
"Gull - meaning: 'Gold'",
"Halldis - meaning: Direct translation would be 'Stone Woman' or 'Stone Deity' although in this case stone could be meant as firm, like 'Firm Woman' or 'Steady/Stable Woman'",
"Hulda - meaning: 'Hidden' or 'Hiding a Secret'",
"Edda - meaning: 'Great Grandmother' or could be meant as 'Wise as an Old Person'",
"Kari - meaning: 'Wind' or 'Gust'",
"Gyrid - meaning: 'God's Strength' or possibly 'God's Peace'",
"Hilde - meaning: 'Battle'",
"Torunn - meaning: 'Beautiful Thor' or 'Thor's Love'",
"Frida - meaning: 'Peace' or another variation for 'Beautiful' or 'Beloved'",
"Torvi - meaning: 'Dedicated to Thunder God'"
];

// Add click event listeners to the gender images
genderImages.forEach(img => {
    img.addEventListener("click", function () {
        // Remove the active class from all images
        genderImages.forEach(img => img.classList.remove("active"));
        // Add the active class to the clicked image
        img.classList.add("active");
    });
});

// Function to generate random names based on gender
function getRandomNames(gender, count) {
    let names = [];
    if (gender === "Male") {
        names = vikingMaleNames;
    } else if (gender === "Female") {
        names = vikingFemaleNames;
    }

    const randomNames = [];

    while (randomNames.length < count) {
        const randomIndex = Math.floor(Math.random() * names.length);
        const randomName = names[randomIndex];
        if (!randomNames.includes(randomName)) {
            randomNames.push(randomName);
        }
    }

    return randomNames;
}

// Function to display generated names in the output container
function displayNames(names) {
    const outputContainer = document.getElementById("output");
    outputContainer.innerHTML = "";

    names.forEach(name => {
        const nameElement = document.createElement("p");
        nameElement.textContent = name;
        outputContainer.appendChild(nameElement);
    });
}

// Function to generate and display names based on the selected gender
generateButton.addEventListener("click", function () {
    const activeImage = document.querySelector("#gender img.active");
    if (activeImage) {
        const gender = activeImage.getAttribute("data-value");
        const generatedNames = getRandomNames(gender, 5);
        displayNames(generatedNames);
    } else {
        alert("Please select a gender first.");
    }
});

// Function to display generated names one by one with a smooth rollout effect
function displayNames(names) {
    const outputContainer = document.getElementById("output");
    outputContainer.innerHTML = "";

    let index = 0;

    function displayNextName() {
        if (index < names.length) {
            const nameElement = document.createElement("p");
            nameElement.textContent = names[index];
            outputContainer.appendChild(nameElement);
            index++;

            // Trigger a reflow to apply the transition effect
            void nameElement.offsetWidth;

            // Apply the fade-in effect by setting opacity to 1
            nameElement.style.opacity = "1";

            // Continue displaying names with a delay of 0.3 seconds (300 milliseconds)
            setTimeout(displayNextName, 400);
        }
    }

    // Start displaying names
    displayNextName();
}